import React, { Fragment, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.scss";
import SigninIdentifier from "./components/SigninIdentifier/signin-identifier";
import Signin from "./components/Signin/signin";
import WeChatComponent from "./components/weChat/weChatComponent";
import WeChatUsernameComponent from "./components/weChat/weChatUsernameComponent";
import WeChatPasswordComponent from "./components/weChat/weChatPasswordComponent";
import { useOnInit } from "./hooks/onInit";
import LoginErrorPage from "./components/loginErrorPage/loginErrorPage";
import Proxy from "./components/proxy/Proxy";
import CloudProxy from "./components/proxy/CloudProxy";
import Logout from "./components/logout/logout";
import MfaProxy from "./components/proxy/MfaProxy";
import { initializeRpDetails } from "./utils/waitForRpDetails";
import setDocumentTitle from "./utils/documentTitle.utils";
import ScrollToTop from "./components/ScrollToTop/scrollToTop";

const PROXY_PAGE_PATHS = [
  "/account-center/proxy.html",
  "/account-center/cloud-proxy.html",
  "/account-center/mfaproxy.html",
  "/account-center/logout.html",
];

const SIGNIN_PAGE_PATHS = [
  "/account-center/signin-identifier.html",
  "/account-center/signin.html",
  "/account-center/simplified-username.html",
  "/account-center/simplified-password.html",
  "/account-center/cloud-signin-identifier.html",
  "/account-center/cloud-signin.html",
  "/account-center/simplified-cloud-username.html",
  "/account-center/simplified-cloud-password.html",
  "/account-center/mfa-signin-identifier.html",
  "/account-center/mfa-signin.html",
];

const isProxyPage = (pathname) =>
  PROXY_PAGE_PATHS.includes(pathname.toLowerCase());

const isSigninPage = (pathname) =>
  SIGNIN_PAGE_PATHS.includes(pathname.toLowerCase());

function App() {
  useOnInit();
  initializeRpDetails();
  const location = useLocation();

  // Set document.title on every route change
  useEffect(() => {
    setDocumentTitle(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (isProxyPage(location.pathname)) {
      window?.tfIdentityGlobals?.showLoader();
      return;
    }

    // Signin pages manage their own loader lifecycle to avoid
    // a blank flash between loader dismissal and component render
    if (!isSigninPage(location.pathname)) {
      window?.tfIdentityGlobals?.hideLoader();
    }
  }, [location.pathname]);


  return (
    <Fragment>
      {/* SSI Header */}
      <ScrollToTop />

      <div className="app-layout">
        <div className="app-content">
          <Routes>
            {/* Standard Sign-in Flow */}
            <Route
              path="account-center/signin-identifier.html"
              element={<SigninIdentifier />}
            />
            <Route path="account-center/signin.html" element={<Signin />} />

            {/* Simplified Flow */}
            <Route
              path="account-center/simplified-username.html"
              element={<SigninIdentifier />}
            />
            <Route
              path="account-center/simplified-password.html"
              element={<Signin />}
            />

            {/* Cloud Sign-in Flow */}
            <Route
              path="account-center/cloud-signin-identifier.html"
              element={<SigninIdentifier />}
            />
            <Route
              path="account-center/cloud-signin.html"
              element={<Signin />}
            />

            {/* Simplified Cloud Flow */}
            <Route
              path="account-center/simplified-cloud-username.html"
              element={<SigninIdentifier />}
            />
            <Route
              path="account-center/simplified-cloud-password.html"
              element={<Signin />}
            />

            {/* MFA Standard Sign-in Flow */}
            <Route
              path="account-center/mfa-signin-identifier.html"
              element={<SigninIdentifier />}
            />
            <Route path="account-center/mfa-signin.html" element={<Signin />} />

            {/* Proxy Pages */}
            <Route
              path="account-center/cloud-proxy.html"
              element={<CloudProxy />}
            />
            <Route path="account-center/proxy.html" element={<Proxy />} />
            <Route path="account-center/MFAproxy.html" element={<MfaProxy />} />

            {/* We Chat Login Pages */}
            <>
              <Route
                path="account-center/wechat/identity-wechat.html"
                element={<WeChatComponent />}
              />
              <Route
                path="account-center/wechat/wechat-username.html"
                element={<WeChatUsernameComponent />}
              />
              <Route
                path="account-center/wechat/wechat-password.html"
                element={<WeChatPasswordComponent />}
              />
            </>

            {/* Utility Pages */}
            <Route
              path="account-center/loginError.html"
              element={<LoginErrorPage />}
            />
            <Route path="account-center/logout.html" element={<Logout />} />
          </Routes>
        </div>

        {/* SSI Footer */}
        {/* <Footer /> */}
      </div>
    </Fragment>
  );
}

export default App;
